export default {
    name : 'helpers',

    init()
    {
        this.run();
    },
    run ()
    {
        this.initScrollTo();
    },

    initScrollTo()
    {
        const elements = document.querySelectorAll('.scroll-to');

        elements.forEach((el) => {
                el.addEventListener('click', function(event){
                    const scrollTo = (event.target.hash) ? event.target.hash : '#contentBlocks';
                    $('html, body').animate({
                        scrollTop: $(scrollTo).offset().top
                    }, 1000);
                })
            }
        );
    },


}
